import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { IconComponent } from '../../icon/icon/icon.component';
import { AvatarAriaLabel } from './contract/avatar-aria-label.contract';
import { AvatarAriaLabelledBy } from './contract/avatar-aria-labelled-by.contract';
import { AvatarImage } from './contract/avatar-image.contract';
import { AvatarLabel } from './contract/avatar-label.contract';
import { AvatarShape } from './contract/avatar-shape.contract';
import { AvatarSize } from './contract/avatar-size.contract';

@Component({
  selector: 'osp-avatar',
  standalone: true,
  imports: [AvatarModule, IconComponent],
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @HostBinding('class')
  protected cssClass = 'osp-avatar';

  @Input() label: AvatarLabel;
  @Input() ariaLabel: AvatarAriaLabel;
  @Input() ariaLabelledBy: AvatarAriaLabelledBy;
  @Input() image: AvatarImage;
  @Input() size: AvatarSize = 'normal';
  @Input() shape: AvatarShape = 'circle';
  @Input() icon: string | null = null;
}
